module.exports = __webpack_public_path__ + "img/bell.35a1f131.svg";